export default {
  "ERRORS": {
    "agree-gdpr": "Pro pokračování musíte souhlasit s GDPR.",
    "at-least-one-adult": "Alespoň jednomu z účastníků musí být více než 18 let.",
    "bad-email-or-password": "Zadali jste špatný e-mail nebo heslo",
    "bad-promo-code": "Zadali jste špatný slevový kupon.",
    "cannot-change-password": "Nepodařilo se nám změnit vaše heslo, zkuste to prosím za chvíli.",
    "cannot-create-reservation": "Bohužel se nepodařilo vytvořit rezervaci, zkuste to prosím za chvíli.",
    "cannot-recover-password": "Nepodařilo se nám obnovit vaše heslo, zkuste to prosím za chvíli.",
    "different-passwords": "Vaše hesla se neshodují",
    "fill-password-required": "Vyplňte prosím všechna políčka u hesel.",
    "fill-required": "Vyplňte prosím všechna povinná pole.",
    "generic-ups": "Ups, něco se nepovedlo, zkuste to prosím za chvíli.",
    "invalid-email-format": "Zadejte email ve správném formátu",
    "invalid-original-password": "Zadali jste špatné původní heslo.",
    "not-accepted-gdpr": "Pro vytvoření účtu musíte souhlasit se zpracováním osobních údajů",
    "not-chosen-air-ticket": "Prosím vyberte si letenku",
    "not-same-passwords": "Zadaná hesla nejsou totožná.",
    "reservation-error": "Omlouváme se, ale kajuta/zájezd kterou jste si vybrali je buď vyprodaný nebo momentálně nedostupný. Kontaktujte nás na telefonu {contactPhone} nebo na mailu {contactEmail} a my se s vámi ihned spojíme a vymyslíme nejlepší možné řešení. Kód chyby: {errorCode}",
    "reservation-too-many-units": "Bohužel již nemáme dostatek jednotek pro Vaši rezervaci. Zbývá nám {countLeft}.",
    "responsible-not-adult": "Zodpovědná osobě musí být minimálně 18 let.",
    "unfilled-passengers-count-1": "Zdá se, že jste zapomněli vyplnit počet cestujících, alespoň 1 osoba musí být dospělá.",
    "unfilled-passengers-count-2": "Vyberte počet cestujících v pravém menu, aby jste mohli pokračovat v objednávce.",
    "wrong-phone-format": "Zadejte prosím telefonní číslo ve formátu 777777777.",
    "contains-diacritics": "Některé pole obsahuje zakázanou diakritiku.",
    "contact-form-send-fail": "Kontaktní formulář se nepodařilo odeslat.",
    "empty-cabins": "Musíte přidat minimálně 1 osobu do jedné z kabin.",
    "invalid-email": "Zadaný email není ve správném formátu.",
    "no-other-terms": "Žádné další termíny",
    "article-not-found": "Článek nenalezen"
  },
  "INFLECTED": {},
  "LABELS": {
    "show-all": "Zobrazit vše",
    "articles": "Články",
    "recommended-cruises": "Vybrané zájezdy",
    "show-other-terms": "Zobrazit další termíny",
    "ship-class": "Lodní třída",
    "with-mandatory-flight": "S povinnou letenkou",
    "without-mandatory-flight": "Bez povinné letenky",
    "reset-filters": "Reset filtrů",
    "news": "Novinky",
    "address": "Adresa",
    "yachting-lectures": "Přednášky o jachtingu",
    "exotic-rums": "Exotické rumy",
    "quality-coffee": "Výběrová káva",
    "selling-point-cc-and-yachtas": "Prodejní místo Costa Cruises, MSC Cruises a Yachta’s",
    "yachtas-coffee": "Yachta's Coffee",
    "stylish-yacht-coffee-shop": "Stylová jachtařská kavárna v Malackách",
    "costa-cruises-today": "Costa Cruises dnes",
    "70-years-of-tradition": "70 let tradice",
    "msc-cruises-today": "MSC Cruises dnes",
    "want-know-more": "Chci vědět víc",
    "cclub-features": "Výhody spojené s Costa Clubem",
    "cclub": "CostaClub",
    "additional-services": "Příplatkové služby",
    "basic-price-excludes": "Základní cena neobsahuje",
    "services-basic-price-includes": "Služby zahrnuty v ceně zájezdu",
    "basic-price-includes": "Základní cena obsahuje",
    "my-cruise": "My cruise",
    "all-inclusive": "All Inclusive",
    "super-all-inclusive": "Super All Inclusive",
    "full-board": "Plná penze",
    "my-drinks-plus": "My Drinks Plus",
    "my-soft-drinks": "My Soft Drinks",
    "my-drinks-young": "My Drinks Young",
    "accomodation-package": "Ubytovací balíček",
    "catering-package": "Stravovací balíček",
    "account-creation": "Vytvoření nového účtu",
    "account-settings": "Nastavení účtu",
    "adult": "Dospělý",
    "adult-with-age": "Dospělý (+18 let)",
    "adults-with-age": "Dospělí (+18 let)",
    "advanced-filtering": "Pokročilé filtrování",
    "adventurous": "Dobrodružná",
    "air-ticket": "Letenka",
    "all-themes": "Všechna témata",
    "all-sails": "Všechny plavby",
    "any-duration": "Libovolná délka",
    "any-port": "Libovolný přístav",
    "any-ship": "Jakákoliv loď",
    "anywhat": "Jakákoliv",
    "anywhere": "Kamkoliv",
    "apply-promo-code": "Uplatnit promo kód",
    "arrival": "Návrat",
    "back-to-orders": "Zpět na přehled zájezdů",
    "back-to-search": "Zpět na vyhledávání",
    "basic-ship-info": "Základní informace o lodi",
    "bed": "Lůžko",
    "book-cabin": "Objednat kajutu",
    "book-single-place": "Objednat 1 místo",
    "book-whole-ship": "Objednat celou loď",
    "cabin": "Kajuta",
    "cabin-and-accomodation-package": "Kajuta a ubytovací balíček",
    "cabin-number": "Číslo kajuty",
    "cabin-reservation": "Rezervace kajut",
    "cabin-type": "Typ kajuty",
    "cabins": "Kajuty",
    "cabins-number": "Počet kajut",
    "cancellation-terms": "Storno podmínky",
    "catamaran": "Katamarán",
    "change-to-version": "Přepnout na {version} verzi",
    "child": "Dítě",
    "child-with-age": "Dítě (1-17 let)",
    "children": "Děti",
    "children-with-age": "Děti (1-17 let)",
    "choose-airport": "Vyberte letiště",
    "choose-cabin": "Vybrat kajutu",
    "show-prices": "Zobrazit ceny",
    "choose-package": "Vybrat balíček",
    "choose-this-cabin": "Vybrat tuto kajutu",
    "city": "Město",
    "close-menu": "Zavřít menu",
    "company-buy": "Nákup na firmu",
    "contact-person": "Kontaktní osoba",
    "contact-form": "Kontaktní formulář",
    "contact-us": "Kontaktujte nás",
    "continue-to-summary": "Pokračovat na shrnutí objednávky",
    "cookies-header": "Spravovat souhlas cookies",
    "cookies-manage": "Spravovat souhlas",
    "cookies-functional-header": "Funkční Cookies",
    "cookies-preferential-header": "Preferenční Cookies",
    "cookies-analytic-header": "Analytická Cookies",
    "cookies-marketing-header": "Marketingová Cookies",
    "cookies-allow-all": "Přijmout vše",
    "cookies-reject": "Odmítnout",
    "cookies-show-preferences": "Zobrazit předvolby",
    "cookies-save-preferences": "Uložit předvolby",
    "cookies-link": "Zásady ochrany osobních údajů",
    "costa-cruises": "Costa Cruises",
    "msc-cruises": "MSC Cruises",
    "count": "Počet",
    "country": "Stát",
    "crew": "Posádka",
    "crew-members-count": "Počet účastníků",
    "croatia": "Chorvatsko",
    "cruise-crew-members-count": "Počet účastníků plavby",
    "cruise-info": "Informace o plavbě",
    "cruise-on-yacht": "Plavba na jachtě",
    "cruise-theme": "Téma plavby",
    "cruiser": "Cruiser",
    "cruises-delegate-interested-button": "Mám zájem",
    "cruises-label": "Nejlepší zážitky na výletních lodích",
    "cruises-on-yachts": "Plavby na jachtách",
    "czech-nationality": "Česká",
    "czech-version": "Česká verze",
    "date-from": "Termín od",
    "date-of-birth": "Datum narození",
    "date-to": "Termín do",
    "day": "Den",
    "day-at-sea": "Den na moři",
    "delivery-mark": "Označení dodávky",
    "departure": "Odjezd",
    "departure-and-return": "Termín a místo vyplutí a návratu",
    "departure-from": "Vyplouvá z",
    "departure-from-port": "Odjezd z přístavu",
    "destination": "Destinace",
    "download-pdf": "Stáhnout PDF",
    "duration-1-6-days": "1-6 dní",
    "duration-7-10-days": "7-10 dní",
    "duration-10-16-days": "10-16 dní",
    "duration-16-and-more-days": "16+ dní",
    "duration-16-and-more-days-label": "Více dní",
    "email": "E-mail",
    "email-address": "Emailová adresa",
    "empty-beds-count": "Počet volných míst",
    "empty-cabins-count": "Počet volných kajut",
    "empty-ship-count": "Počet lodí k rezervaci",
    "exotic": "Exotická",
    "experience-yacht": "Zažijte dobrodružství na jachtě",
    "family-friendly": "Rodinně pohodová",
    "favorite-cruises": "Nejoblíbenější plavby",
    "favorite-routes": "Nejoblíbenější trasy",
    "female": "Žena",
    "files-to-download": "Soubory na stažení",
    "fill-different-passengers-count": "Zadat jiný počet pasažérů",
    "filter": "Filtrovat",
    "first-name": "Křestní jméno",
    "fitness": "Fitness",
    "fogotten-password-q": "Zapomněli jste heslo?",
    "for-cabin": "Za kajutu",
    "for-captains": "Pro kapitány",
    "for-person": "Za osobu",
    "forgotten-password": "Zapomenuté heslo",
    "from": "Od",
    "from-cheapest": "Od nejlevnějšího",
    "gdpr": "Zpracování osobních údajů",
    "greece": "Řecko",
    "guests": "Hosté",
    "hide": "Skrýt",
    "how-it-works": "Jak to funguje",
    "in-total": "Celkem",
    "includes-transport": "Včetně dopravy",
    "info-about-cabins": "Informace o kajutách",
    "info-about-destination": "Informace o destinacích",
    "info-about-packages": "Informace o ubytovacích balíčcích",
    "info-about-trip-crew": "Informace o účastnících zájezdu",
    "info-about-yachting": "Informace o jachtingu",
    "item": "Položka",
    "itinerary": "Plán plavby",
    "itinerary_arrival": "Připlutí",
    "itinerary_departure": "Vyplutí",
    "lamour": "L'amour",
    "last-name": "Příjmení",
    "life-on-cruiser": "Život na výletní lodi",
    "login": "Přihlásit se",
    "login-to-account": "Přihlášení k účtu",
    "logout": "Odhlásit se",
    "longest": "Nejdelší",
    "male": "Muž",
    "max-120-days": "Maximálně 120 dní",
    "max-30-days": "Maximálně 30 dní",
    "max-60-days": "Maximálně 60 dní",
    "max-90-days": "Maximálně 90 dní",
    "message": "Zpráva",
    "more-about-cruise": "Více o plavbě",
    "more-about-ship": "Více o lodi",
    "more-information": "Více informací",
    "more-fb-reviews": "Více FB recenzí",
    "more-google-reviews": "Více Google recenzí",
    "my-trips": "Moje plavby",
    "nationality": "Národnost",
    "nautyy": "Nautyy",
    "new-password": "Nové heslo",
    "new-registration": "Nová registrace",
    "next": "Další",
    "no": "Ne",
    "no-worries-both-way": "Bez starostí tam a zpět",
    "order-summary": "Shrnutí objednávky",
    "original-password": "Původní heslo",
    "other-cruises": "Další plavby na výletní lodi",
    "other-cruises-on-yacht": "Další plavby na plachetnici",
    "other-features": "Další výhody",
    "overall-price": "Cena celkem",
    "overall-price-for": "Cena celkem za {for}",
    "package": "Balíček",
    "passanger-count": "Počet pasažérů",
    "passenger": "Pasažér",
    "password": "Heslo",
    "password-again": "Heslo znovu",
    "pay-25-deposit": "Uhradit depozit 25% z celkové ceny",
    "pay-50-deposit": "Uhradit depozit 50% z celkové ceny",
    "pay-deposit": "Uhradit depozit",
    "pay-deposit-with-card": "Zaplatit depozit 25% ceny",
    "pay-remaining": "Doplatit zbytek částky",
    "pay-everything": "Uhradit celou částku",
    "pay-everything-once": "Uhradit celou částku najednou",
    "pay-with-bank": "Uhradit bankovním převodem",
    "pay-with-card": "Uhradit platbou online",
    "payment": "Platba",
    "payment-terms-reservation": "Podmínky platby a rezervace",
    "people-count": "Počet osob",
    "person": "Osoba",
    "personal-details": "Osobní údaje",
    "phone-number": "Telefonní číslo",
    "phone-prefix": "Předvolba",
    "prev": "Předchozí",
    "price-first-person": "Cena pro 1. osobu",
    "price-for-cabin": "Cena za kajutu",
    "price-for-one-person-from": "Cena pro 1. osobu od",
    "price-for-single": "Cena za 1 osobu",
    "price-for-single-from": "Cena za 1 osobu od",
    "price-for-two-people": "Cena za 2 osoby",
    "price-for-whole-ship": "Cena za celou loď",
    "prices-shown-for": "Ceny uvedeny za",
    "product": "Produkt",
    "promo-code": "Promo kód",
    "promo-code-discount": "Sleva promo kód",
    "promo-cruises": "Akční plavby",
    "recover-password": "Obnovit heslo",
    "register": "Registrovat se",
    "register-account": "Registrovat účet",
    "repeat-new-password": "Zopakujte nové heslo",
    "repeat-password": "Zopakujte heslo",
    "reservation-type": "Typ rezervace",
    "responsible-person": "Zodpovědná osoba",
    "return-air-ticket": "Zpáteční letenka",
    "review-talking": "Říkají o nás",
    "sail-date": "Termín a místo vyplutí a návratu",
    "sail-duration": "Délka plavby",
    "sail-one-way": "Jednosměrné plavby",
    "sail-type": "Typ plavby",
    "save": "Uložit",
    "search-cruise": "Vyhledat plavbu",
    "search-trips": "Vyhledat zájezdy",
    "send": "Odeslat",
    "service": "Služba",
    "sex": "Pohlaví",
    "sex-unspecified": "Neznámý",
    "ship": "Loď",
    "ship-length": "Délka lodě",
    "ship-type": "Typ lodi",
    "ship-width": "Šířka lodě",
    "shortest": "Nejkratší",
    "show": "Zobrazit",
    "show-cruises": "Zobrazit plavby",
    "show-price": "Zobrazit cenu",
    "show-all-promo-cruises": "Zobrazit všechny akční plavby",
    "show-all-delegate-cruises": "Zobrazit všechny plavby s delegátem",
    "single-reservation": "Rezervace míst",
    "slovak-nationality": "Slovenská",
    "slovak-version": "Slovenská verze",
    "soldout": "Vyprodáno",
    "soonest-departure": "Nejbližší odjezd",
    "sort": "Řadit",
    "sort-by": "Řadit dle",
    "special-offers": "Speciální nabídky",
    "speed-in-knots": "Rychlost v uzlech",
    "state": "stav",
    "street-and-number": "Ulice a číslo popisné",
    "subscribe": "Přihlásit k odběru",
    "sum": "Součet",
    "summary": "Shrnutí",
    "to": "Do",
    "to-cruise-search": "Přejít na vyhledávání plaveb",
    "to-payment-and-reservation": "Přejít k platbě a rezervovat",
    "to-summary": "Přejít ke shrnutí",
    "to-trip-search": "Přejít na vyhledávání zájezdů",
    "total-price": "Konečná cena",
    "total-time": "Celková doba",
    "total-to-pay": "Celkem k úhradě",
    "transport": "Doprava",
    "transport-and-offers": "Doprava a další nabídky",
    "transport-to-port": "Doprava do přístavu",
    "what-to-bring": "Co sebou?",
    "travel-on-ship": "Cestujte na lodi",
    "travellers": "Cestující",
    "travellers-count": "Počet cestujících",
    "trip": "Zájezd",
    "trip-info": "Informace o zájezdu",
    "upcoming-trips": "Nadcházející plavby",
    "weight": "Hmotnost",
    "where-to": "Kam vyrazíme?",
    "where-we-sailing-this-year": "Kam se letos plavíme",
    "when-depart": "Kdy vyrazíme?",
    "whole-ship": "Celá loď",
    "without-air-ticket": "Bez letenky",
    "yacht": "Plachetnice",
    "yacht-reservation": "Rezervace lodí",
    "yachtas-label": "Plavby na jachtě, plachetnici a katamaránu",
    "yes": "Ano",
    "you-choose-cabin": "Vyber si kajutu",
    "you-login": "Přihlašte se",
    "you-register": "Zaregistrujte se",
    "zip": "PSČ",
    "everything-sold-out": "Všechna místa jsou vyprodána",
    "for-firms": "Pro firmy",
    "team-building": "Team building",
    "order-firm-cruise": "Objednat plavbu pro firmu",
    "individual-price": "Individuální cena",
    "dream-program": "Program podle vašich představ",
    "custom-transport": "Doprava na míru",
    "for-firms-taxes": "Nákladová položka",
    "delegate-services": "Služby delegáta",
    "sales-department": "Obchodní oddělení",
    "for-groups": "Pro skupiny",
    "order-group-cruise": "Objednat plavbu pro skupinu",
    "groups-from-8-people": "Skupiny již od 5 kajut",
    "port-excursions": "Exkurze v přístavech",
    "contact": "Kontakt",
    "info-about-costa-cruises": "Informace o plavbách s Costa Cruises",
    "info-about-msc-cruises": "Informace o plavbách s MSC Cruises",
    "inner-cabin": "Vnitřní kajuta",
    "sea-view-cabin": "Kajuta s výhledem na moře",
    "terrace-cabin": "Kajuta s terasou",
    "balcony-cabin": "Kajuta s balkonem",
    "mini-apartman": "Mini apartmán",
    "apartman-cabin": "Apartmán",
    "luxury-apartman-cabin": "Luxusní apartmán",
    "order-cruise": "Objednat plavbu",
    "food": "Strava",
    "luggage": "Zavazadla",
    "restrictions": "Omezení",
    "fun-on-ship": "Zábava na lodi",
    "excursions": "Exkurze a pohyb mimo loď",
    "portal-mycosta": "Portál MyCosta",
    "app-costa": "Aplikace Costa",
    "next-information": "Další informace",
    "online-check-in": "Online check-in",
    "payments-on-ship": "Platby na lodi",
    "internet-connection": "Připojení k internetu",
    "medical-care": "Lékařské ošetření na lodi",
    "travel-documents": "Cestovní dokumenty",
    "add-cabin": "Přidat další kajutu",
    "remove-cabin": "Odebrat kajutu",
    "capacity": "Kapacita",
    "price-per-person": "Cena za osobu",
    "description": "Popis",
    "arrival-time": "Příjezd",
    "departure-time": "Odjezd",
    "your-delegate": "Váš delegát",
    "what-will-you-sail-on": "Na čem poplujete",
    "cruises-with-delegate": "Plavby s delegátem",
    "cruises-with-czech-delegate": "Plavby s českým delegátem a dopravou",
    "cruises-without-delegate": "Plavby bez delegáta",
    "with-delegate": "S delegátem",
    "menu": "Menu",
    "any-company": "Jakákoliv společnost",
    "portal-msc": "MSC for Me",
    "mscyc": "MSC Yacht Club",
    "internet": "Internet",
    "sport": "Sport",
    "packages": "Balíčky",
    "drinks": "Nápoje",
    "select": "Vybrat",
    "cancel": "Zrušit",
    "ports": "Přístavy",
    "goes-through": "Pluje přes",
    "select-ports": "Vyberte přístavy",
    "select-packages": "Vyberte balíčky",
    "select-cabins": "Vyberte kajuty",
    "gallery": "Galerie",
    "cruise-dates": "Další termíny plavby",
    "dont-know-where": "Nevíte kam?"
  },
  "LINKS": {
    "about-company": "O společnosti",
    "account-settings": "Nastavení profilu",
    "contacts": "Kontakty",
    "cruiser-holidays": "Dovolená na lodi",
    "cruiser-trip": "Zájezd na cruiseru",
    "faq": "Časté dotazy",
    "gdpr": "GDPR",
    "my-trips": "Mé zájezdy",
    "our-captains": "Naši kapitáni",
    "site-map": "Mapa webu",
    "terms-and-conditions": "Obchodní podmínky",
    "yacht-holidays": "Dovolená na plachetnici",
    "yacht-trip": "Plavby na plachetnici",
    "yachtas-coffee": "Kavárny YACHTA'S"
  },
  "MONTHS": {
    "January": "Leden",
    "February": "Únor",
    "March": "Březen",
    "April": "Duben",
    "May": "Květen",
    "June": "Červen",
    "July": "Červenec",
    "August": "Srpen",
    "September": "Září",
    "October": "Říjen",
    "November": "Listopad",
    "December": "Prosinec"
  },
  "MONTHS-SHORT": {
    "January": "Led",
    "February": "Únor",
    "March": "Břez",
    "April": "Dubn",
    "May": "Květ",
    "June": "Čvn",
    "July": "Čvnc",
    "August": "Srp",
    "September": "Září",
    "October": "Říjn",
    "November": "List",
    "December": "Pros"
  },
  "STATUSES": {
    "loading": "Načítání...",
    "all-saved": "Vše bylo úspěšně uloženo.",
    "applying-promo": "Ověřujeme zadaný promo kód",
    "cancelled": "Zrušeno",
    "completed": "Dokončeno",
    "creating-reservation": "Vytváříme rezervaci",
    "holding-cabin": "Rezervujeme pro Vás kajutu",
    "instructions-sent": "Instrukce pro obnovení hesla jsme vám poslali na e-mail",
    "loading-cruise": "Načítám informace o plavbě",
    "init-workflow": "Připravuji rezervační systém",
    "loading-workflow": "Načítám rezervační systém",
    "loading-external": "Získávám aktuální data od plavební společnosti",
    "loading-packages-note": "Načítám informace o balíčcích",
    "loading-package-note": "Načítám informace o balíčku",
    "loading-cabins-note": "Načítám informace o typech kajut",
    "loading-cruise-info": "Načítáme informace o plavbě",
    "loading-banner": "Načítám banner",
    "loading-itinerary": "Načítám trasu plavby",
    "loading-ship-info": "Načítám informace o lodi",
    "loading-recommended-cruises": "Načítám doporučené plavby",
    "loading-flights": "Načítám informace o letech",
    "loading-order-summary": "Načítáme shrnutí objednávky",
    "loading-packages": "Načítáme ubytovací balíčky",
    "loading-page": "Stránka se načítá",
    "loading-reservation-info": "Načítáme informace o rezervaci",
    "loading-reservation-payment": "Načítáme platební informace",
    "loading-reservation-summary": "Načítáme shrnutí rezervace",
    "loading-trip-info": "Načítáme informace o zájezdu",
    "loading-your-cruises": "Načítáme Vaše plavby",
    "logging-in": "Probíhá přihlašování",
    "not-available": "Není dostupná",
    "paid-deposit": "Zaplacen depozit",
    "paid-full": "Zaplaceno vše",
    "password-successfully-changed": "Heslo bylo úspěšně změněno, můžete se přihlásit.",
    "pay-amount-at-once": "Úhrada celé částky najednou",
    "pay-with-bank-description": "Platba klasickým bankovním převodem z vašeho účtu. Platební údaje obdržíte emailem.",
    "pay-with-card": "Zaplatit pomocí platební brány online",
    "pay-with-card-description": "Platba pomocí online platební brány. Platba je provedena okamžitě po potvrzení.",
    "promo-successfully-applied": "Úspěšně jste uplatnili slevový kupon. Z celkové ceny vašeho nákupu jsme odečetli {priceText}.",
    "registering": "Probíhá registrace Vašeho účtu",
    "reservation-cancelled": "Tato rezervace byla stornována.",
    "reservation-cancelled-deposit": "Vaše rezervace byla stornována. Kontaktujte nás ohledně možností vrácení platby",
    "reservation-paid": "Cena plavby byla již kompletně uhrazena.",
    "reservation-paid-deposit": "Uhradili jste depozit ve výši {paidPrice}. Zbývá doplatit {unpaidPrice} nejpozději do {dueDate}. Platební údaje jsme vám zaslali do emailu.",
    "reservation-waiting-for-payment": "Tuto rezervaci je nutné co nejdříve uhradit. Platební údaje najdete v souborech ke stažení níže.",
    "saving-cabin": "Ukládáme volbu kajuty",
    "saving-data": "Aktualizujeme změněné údaje",
    "saving-package": "Ukládáme volbu ubytovacího balíčku",
    "saving-password": "Aktualizujeme Vaše heslo",
    "saving-transport": "Ukládáme volbu dopravy",
    "searching-cruises": "Vyhledáváme plavby",
    "searching-trips": "Vyhledáváme zájezdy",
    "sending-instruction-email": "Odesíláme Vám e-mail s instrukcemi",
    "waiting-for-payment": "Čekající na platbu",
    "without-price-for-transport": "Bez ceny za dopravu"
  },
  "TEXTS": {
    "msc-cruises-tradition-1": "MSC Cruises patří mezi nejrychleji rostoucí lodní společnosti na světě a je symbolem elegance, udržitelnosti a špičkových zážitků na moři.",
    "msc-cruises-tradition-2": "Společnost byla založena v roce 1970 jako součást Mediterranean Shipping Company, druhého největšího provozovatele kontejnerové dopravy na světě. Svou první výletní loď, <b>Monterey</b>, představila v roce 1988. Od té doby MSC Cruises úspěšně kombinuje rodinnou tradici s nejmodernějšími technologiemi a dokázala se etablovat jako lídr na evropském i světovém trhu.",
    "msc-cruises-tradition-3": "Sídlo společnosti se nachází ve švýcarské Ženevě, kde se potkává švýcarská preciznost s italským šarmem. MSC Cruises tak spojuje nejlepší aspekty evropské kultury, což je viditelné v každém detailu – od designu lodí až po služby na palubě.",
    "msc-cruises-now-1": "Flotila MSC Cruises se pyšní více než 20 moderními loděmi, které nabízejí špičkový komfort, udržitelné technologie a prvotřídní zážitky. Mezi její vlajkové lodě patří <b>MSC World Europa</b> a <b>MSC Euribia</b>, které patří k nejmodernějším a nejekologičtějším lodím současnosti díky pohonu na LNG a dalším inovacím snižujícím dopad na životní prostředí.",
    "msc-cruises-now-2": "MSC Cruises nabízí jedinečné zážitky, jako je <b>MSC Yacht Club</b>, exkluzivní část lodi s apartmány, soukromým bazénem a 24/7 osobním butlerem. Lodě MSC jsou známé také svou rozmanitou kuchyní – od tradičních středomořských specialit po mezinárodní gurmánské pokrmy – a zábavou světové úrovně, včetně spolupráce s Cirque du Soleil.",
    "msc-cruises-now-3": "Společnost přepraví každoročně miliony spokojených cestujících do více než 200 destinací ve 90 zemích světa. Mezi oblíbené cíle patří Karibik, Středomoří, Severní Evropa nebo exotičtější oblasti, jako je Jižní Amerika a Indický oceán.",
    "msc-cruises-now-4": "S více než 30 000 zaměstnanci z celého světa MSC Cruises neustále rozšiřuje svou flotilu a služby. Díky propojení tradice, inovací a důrazu na zákaznickou spokojenost se společnost stala synonymem pro nezapomenutelné plavby.",
    "book-cruise-in-coffeeshop": "Rezervujte si plavbu přímo v kavárně",
    "yachtas-coffee-detail-1": "Dovolená by se podle nás měla vybírat bez stresu <b>s dortíkem a výbornou kávou v ruce</b>. Proto jsme vymysleli koncept, kde přesně toto můžete zažít.",
    "yachtas-coffee-detail-2": "Přijďte nás navštívit do naší kavárny v Malackách, která mimo jiné také <b>slouží jako prodejní místo zájezdů</b> společností Costa Cruises, MSC Cruises a Yachta's.",
    "yachtas-coffee-detail-3": "Pravidelně také <b>pořádáme přednášky</b> s osobnostmi českého a slovenského jachtingu.",
    "yachtas-coffee-note": "Brzy nás také najdete na dalších místech v České republice.",
    "content-yachtas-coffee-under-hero": "<b>Vyberte si a objednejte zájezd přímo v kavárně.</b><br>V kavárně YACHTA'S vám pomůžeme s rezervací vaší plavby na jachtě nebo cruiseru.",
    "costa-cruises-now-1": "Nyní <b>Costa Cruises vlastní jednu z nejmodernějších flotil</b> a od roku 2018 zařadila do provozu 4 nové výletní lodě. Mezi ně patří také dvě z <b>největších lodí svého druhu</b> na světě – Costa Smeralda a vlajková loď Costa Toscana.",
    "costa-cruises-now-2": "Obě tyto lodě byly <b>postaveny s ohledem na životní prostředí</b> a plují na zkapalněný zemní plyn. Costa Cruises provozuje 11 lodí, zaměstnává více než 18 000 lidí a plaví se do destinací po celém světě.",
    "costa-cruises-now-3": "Společnost Costa Cruises se proslavila <b>tradiční italskou gastronomií</b>, pohostinností a elegancí na palubě svých lodí.",
    "costa-cruises-tradition-1": "Costa Cruises je již <b>více než 70 let jedním z lídrů</b> na trhu námořních plaveb v Evropě.",
    "costa-cruises-tradition-2": "Společnost byla založena v roce 1854. První plavbu s pasažéry ale podnikla až 31. března 1948, kdy Anna C vyplula z Janova do Buenos Aires. V roce 1957 si společnost Costa Cruises nechala postavit <b>historicky první výletní loď</b> Franca C – jednu z nejdéle aktivních lodí svého druhu na světě. V roce 2009 byla po 59 letech vyřazena z provozu.",
    "costa-cruises-tradition-3": "Za 70 let se italská společnost, stejně jako nároky zákazníků, vyvinula. Stále si ale zakládá na stejných hodnotách a jako jedna z mála se neuzpůsobila americkému trhu. Naopak <b>zůstala věrná svým kořenům</b> a do dnes se lodě Costa Cruises hrdě plaví pod italskou vlajkou.",
    "content-costa-cruises-under-hero": "<b>Ubytování, strava, služby a více.</b><br>Vše co potřebujete vědět o plavbě na cruiseru.",
    "cruise-on-yacht-text": "Láká vás romantika, pohoda i objevování na jachtě či katamaránu? <b>Zažijte neuvěřitelnou plavbu</b> s YACHTA's.",
    "cclub-features-1": "Registrace zdarma.",
    "cclub-features-2": "Slevy pro členy na vybrané zájezdy již při 1. plavbě.",
    "cclub-features-3": "Až 50% slevy na služby na palubě.",
    "cclub-features-4": "Slevy na vybrané exkurze.",
    "cclub-features-5": "Slevy na další plavby až 20%.",
    "cclub-features-6": "Upgrade kajuty zdarma (dle dostupnosti).",
    "cclub-features-7": "Mnoho dalších výhod",
    "cclub-features-footer": "V případě zájmu o členství v C&#124;Club nás neváhejte kontaktovat na <a href='mailto:{email}'>{email}</a>",
    "basic-price-excludes-1": "<b>Dopravu</b> do místa a z místa vyplutí.",
    "basic-price-excludes-2": "Služby <b>průvodce</b> nebo <b>delegáta.</b> u plaveb u kterých to není spoecifikováno.",
    "basic-price-excludes-3": "<b>Alkoholické a nealkoholické nápoje</b>",
    "basic-price-excludes-4": "<b>Fakultativní výlety.</b>",
    "basic-price-excludes-5": "<b>Nadstandardní služby</b> - prádelna, wellness, salón krásy, internetové balíčky, lékařské ošetření na palubě.",
    "basic-price-excludes-6": "<b>Servisní poplatky</b> ve výši 11€ za osobu a den, děti 4-14 let 5,5€ za osobu a den.",
    "basic-price-excludes-7": "<b>Cestovní pojištění.</b>",
    "basic-price-excludes-8": "<b>Pojištění storna</b> zájezdu.",
    "basic-price-excludes-9": "<b>Pojištění zavazadel.</b>",
    "basic-price-excludes-10": "<b>15% servisní poplatek</b> účtovaný při každé objednávce služeb nebo nápojů (V případě zakoupení balíčků je již poplatek v ceně).",
    "basic-price-excludes-footer": "V případě zájmu o některé z výše uvedených služeb nás neváhejte kontaktovat na <a href='mailto:{email}'>{email}</a>",
    "basic-price-includes-1": "<b>Ubytování</b> v kajutě vybrané kategorie.",
    "basic-price-includes-2": "<b>Balíček MyCruise</b> - plná penze v bufetové nebo á la cart restauraci.",
    "basic-price-includes-3": "Nápoje dle zvoleného balíčku.",
    "basic-price-includes-4": "Využití veřejných <b>rekreačních a relaxačních zařízení</b> – bazény, vířivky, posilovna, sportovní hřiště.",
    "basic-price-includes-5": "<b>Animační programy.</b>",
    "basic-price-includes-6": "<b>Divadelní představení</b> dle denního rozvrhu, <b>živá hudba.</b>",
    "basic-price-includes-7": "<b>Přístavní poplatky</b>",
    "basic-price-includes-8": "<b>Asistenční službu v případě potíží od společnosti NAUTYY</b>",
    "basic-price-includes-9": "<b>lužby delegáta v případě plaveb skupinových plaveb s delegátem</b>",
    "basic-price-includes-footer": "Výše uvedené služby jsou obsaženy v balíčku MyCruise i All Inclusive.",
    "my-drinks-young-feature-1": "Nealkoholické koktejly, ovocné džusy, horké nápoje, horká čokoláda, voda a více...",
    "my-soft-drinks-feature-1": "Neomezená konzumace <b>nealkoholických nápojů.</b>",
    "my-drinks-plus-feature-1": "Neomezená konzumace <b>prémiového alkoholu.</b>",
    "super-all-inclusive-feature-1": "Všechny výhody jako balíček <b>All Inclusive.</b>",
    "super-all-inclusive-feature-2": "Navíc v ceně výběr 3 exkurzí z balíčku <b>My Explorations.</b>",
    "all-inclusive-feature-1": "<b>Plná penze</b> - bufetová nebo á la cart restaurace.",
    "all-inclusive-feature-2": "<b>Nápojový balíček „MyDrinks“</b> - neomezená konzumace alkoholických i nealkoholických nápojů (rozlévané víno, točené pivo, káva, voda, míchané alkoholické i nealkoholické nápoje, džusy, limonády a více…)",
    "all-inclusive-feature-3": "Možnost výběru <b>času večeře</b> (dle dostupnosti).",
    "all-inclusive-feature-4": "Extra body do CostaClubu",
    "my-cruise-feature-1": "Tento balíček <b>je v základní ceně zájezdu</b>.",
    "my-cruise-feature-2": "<b>Plná penze</b> - bufetová nebo á la cart restaurace.",
    "my-cruise-feature-3": "<b>Nápoje pouze během snídaně</b> - voda, rozlévaná káva, čaj, u svačiny, oběda a večeře pouze voda v bufetové restauraci.",
    "my-cruise-feature-4": "Možnost výběru <b>času večeře</b> (dle dostupnosti).",
    "how-it-works-heading-1": "Vybrat si můžete z následujících stravovacích balíčků.",
    "how-it-works-heading-2": "s vlastním výběrem kajuty a plnou penzí.",
    "how-it-works-subtitle-1": "Jednoduchá a Pohodlná Rezervace",
    "how-it-works-subtitle-2": "Online Rezervace a Platební Možnosti",
    "how-it-works-subtitle-3": "Rezervace s expertem na plavby",
    "how-it-works-subtitle-4": "Všechny Výhody Costa Cruises u Nás",
    "how-it-works-text-1": "U nás máte možnost objednat svou plavbu s Costa Cruises tak, jak vám to nejvíce vyhovuje. Máte na výběr mezi dvěma jednoduchými způsoby rezervace, které vám umožní plánovat svou dokonalou dovolenou na moři. Můžete objednat online a zaplatit kartou anebo se spojit s našimi kolegy, kteří vám rádi poradí a vše vysvětlí.",
    "how-it-works-text-2": "Jsme jediní v české republice, u koho můžete plavbu objednat jednoduše a rychle online z pohodlí domova. Dostupnost kajut a všechny ceny na našem webu jsou aktuální. Nemusíte tak vyplňovat poptávkový formulář a poté čekat, zda je nabízená plavba stále volná nebo zda je opravdu za cenu, za kterou je inzerována. Vaše rezervace je automaticky ihned po zaplacení potvrzena a vy se již můžete těšit na plavbu. Další služby je možné dokoupit i po vytvoření rezervace.",
    "how-it-works-text-3": "Máte speciální požadavky, nebo jste na výletní lodi ještě nebyli a máte jakékoliv dotazy? Stačí nám zavolat nebo napsat na e-mail. Probereme s vámi veškeré detaily a vytvoříme nabídku podle vašich představ. Zároveň vám vysvětlíme, jak vše funguje.",
    "how-it-works-text-4": "Jako autorizovaný zástupce Costa Cruises si k cenám nepřidáváme žádné přirážky a nabízíme našim zákazníkům všechny výhody, které tato společnost poskytuje. Můžete využít všech výhod členství v Costa Clubu a získat tak až 20% slevu na vybrané plavby nebo upgrade kajuty zdarma. V případě zájmu o členství C-Club nás kontaktujte. V případě jakýchkoliv problémů nebo speciálních žádostí komunikujete přímo s námi, takže nemusíte ztrácet čas čekáním na infolince. A hlavně vše řešíte česky.",
    "how-and-why-costa": "Proč a jak si objednat Plavbu s Costa Cruises",
    "about-food-text-1": "Na palubách lodí Costa Cruises budete <b>mít možnost ochutnat jak tradiční italské pokrmy, tak i jídlo ze všech koutů světa v mnoha tematických restauracích, které na vás na palubě čekají.</b>",
    "about-food-text-2": "V À la carte restauraci na vás bude čekat večeře s několika chody a na výběr budete mít vždy jak z italských jídel, tak i z tradičních pokrmů připravenými pro danou destinaci. Menu je vytvořeno vyhlášenými světovými kuchaři.",
    "about-food-text-3": "Bufetová restaurace je otevřená skoro po celý den a je v ní udržován standart stejný jako v À la carte restauraci.",
    "about-food-text-4": "Na výběr máte také z mnoha tematických restaurací jako jsou například Archipelago, kde můžete ochutnat molekulární kuchyni od michelinských kuchařů, Sushino at Costa, Tepyaniaki, Pummid’Oro Pizzera, La Fiorentina Steak House, KikiPoke nebo Dim Sum a Noodle Bar. Stravování v těchto restauracích však není v ceně základního balíčku.",
    "about-food-text-5": "Na hosty apartmánů a nejvyšších úrovních Costa Clubu čeká <b>soukromá elitní restaurace určená pouze pro ně.</b>",
    "about-food-text-6": "Na lodích také najdete několik tematických barů. Mezi ně patří Aperol Spritz bar, Frescobaldi vinný bar, pivní bar a mnoho dalšího.",
    "about-food-text-7": "Děti si mohou užít například Gelaterie Amarillo s velkým výběrem zmrzlin nebo Nutellového baru na Costě.",
    "about-food-text-8": "K dispozici je i speciální dieta (bezlepková, bezlaktózová, atd). Speciální stravu je však nutno objednat předem.",
    "about-cabin-text-8": "<b>Výhody apartmánu:</b><br>balíček MyDrinks plus v ceně<br>24 – 43 m2 apartmán a 8 – 32m2 balkon<br>přivítací balíček - šumivé víno a canapés<br>vstup do Wellness zóny na jeden den<br>klubové/elitní restaurace<br>VIP zóna na 19. patře (Costa Toscana a Costa Smeralda)<br>VIP personál<br>VIP vstup na loď a přednostní nalodění,<br>pokojová služba a osobní komorník<br>VIP manažer v případě jakýchkoliv žádostí<br>možnost výběru z více druhů polštářů<br>stravování se na pokoji",
    "about-cabin-text-7": "Pro nejnáročnější klienty jsou k dispozici apartmány a luxusní apartmány.",
    "about-cabin-text-6": "<b>Vybavení kajut</b><br>Prostorná koupelna včetně toalety<br>Pohodlné velké lůžko<br>Pohodlná<br>klimatizace<br>Širokoúhlá TV<br>minibar<br>šatní skříň<br>kosmetickým stolek<br>fén na vlasy<br>trezor<br>telefon",
    "about-cabin-text-5": "Kajuty jsou rozděleny do kategorií 1 až 4. Vybavením se kajuty nijak neliší, rozdíl je pouze v umístění a případně velikosti kajut a balkónu. Obecně platí, čím vyšší kategorie, tím vyšší patro. U vyšších kategorií kajut máme také možnost vybrat přesné umístění. Stačí nám zavolat nebo napsat a můžeme ji vybrat společně.",
    "about-cabin-text-4": "<b>Kategorie kajut</b>",
    "about-cabin-text-3": "<b>Vybrat si můžete z následujících typů kajut:</b>",
    "about-cabin-text-2": "Kajuty uspokojí jak zákazníky s omezeným rozpočtem, tak i náročnější klienty, kteří vyhledávají vyšší standard ubytování.",
    "about-cabin-text-1": "Kajuty na lodích Costa Cruises spojují to nejlepší z moderního a klasického italského stylu. Všechny lodě jsou inspirovány italskými oblastmi nebo městy.",
    "content-how-it-works-under-hero": "<b>Ubytování, strava, služby a více.</b><br>Vše co potřebujete vědět o plavbě na cruiseru",
    "contact-us-text": "Jsme vám k dispozici běžně v pracovních hodinách každý všední den. Naše priorita je vaše bezstarostná dovolená.",
    "we-are-here-for-any-question": "Máte otázky ohledně rezervace, plavby nebo čehokoliv jiného? <b>Jsme zde pro vás.</b>",
    "carefree-cruise": "Jsme zde pro vaši bezstarostnou plavbu",
    "port-excursions-text": "<b>Využijte čas v každém z přístavů na maximum</b> a poznejte je skutečně do hloubky. S profesionálním průvodcem to není žádný problém.",
    "group-of-friends-text": "Při cestování s přáteli vznikají ty nejlepší vzpomínky. Pro skupiny 5 a více kajut dokážeme zajistit <b>kajuty vedle sebe, lepší cenu a další výhody.</b>",
    "content-for-groups-under-hero": "<b>Zažijte parádní jízdu se svými přáteli.</b> Plavby pro skupiny pěti a více kajut.",
    "how-to-order-group-cruise": "Jak objednat zájezd pro více osob",
    "contact-bubble-text": "<b>Pokud máte dotazy</b> k průběhu plavby, k objednávce, chcete individální nabídku pro skupinu, firmu a nebo cokoliv jiného, <b>neváhejte mě kontaktovat</b>.",
    "contact-cruise-text": "<b>Pokud máte dotazy</b> k průběhu plavby, k objednávce, chcete individální nabídku pro skupinu, firmu a nebo cokoliv jiného, <b>neváhejte nás <a href='{href}'>kontaktovat<a/></b>.",
    "delegate-services-text": "Barcelona, Casablanca, Malaga, Savona a Marseilles v jednom týdnu? Proč ne. S Nautyy navštívíte ty <b>nejkrásnější přístavní města na světě</b> a s profesionálním delegátem můžete hodit starosti za hlavu.",
    "for-firms-taxes-text": "Všechny zájezdy, které u nás zakoupíte si <b>můžete dát do účetnictví jako nákladovou položku</b>. V případě individuálních požadavků pro vás připravíme řešení, dle vašich potřeb.",
    "custom-transport-text": "Zapomeňte na starosti spojené s dopravou na letiště, letenkami a taxiky. <b>Kompletní dopravu přímo na loď i zpět pro vás kompletně zajistíme</b>.",
    "dream-program-text": "Lodě nabízí tolik možností, že je za týdenní plavbu jen stěží stihnete všechny vyčerpat. Pomůžeme vám sestavit <b>program plný nezapomenutelných zážitků</b> šitý přímo vám na míru.",
    "individual-price-text": "Jsme certifikovaným partnerem Costa Cruises a MSC Cruises, a proto pro vás <b>dokážeme zajistit cenu, kterou jinde nezískáte</b>. Napište nám a poptejte cenovou nabídku.",
    "team-building-text": "Dopřejte vašemu týmu tu <b>nejlepší kombinaci pohody a dobrodružství</b>. Na cruiseru na vás čekají pohodlné kajuty, široký výběr restaurací, bazény, kasína, kino i divadlo. Přitom jste stále v pohybu a každý den navštívíte novou světovou metropoli.",
    "content-for-firms-under-hero": "Připravíme vám <b>firemní dovolenou na míru</b> podle vašich představ.",
    "cruise-with-costa-for-firms": "Zájezd pro firmy",
    "no-diacritics": "Veškeré informace do formulářů zadávejte bez diakritiky.",
    "pay-note": "Po uhrazení celkové částky bude vaše rezervace dokončena. Všechny důležité informace vám pak zašleme emailem.",
    "price-to-pay": "Celková částka k úhradě",
    "price-deposit-to-pay": "Depozit ve výši 25%",
    "pay-and-finish-order": "Zaplatit a dokončit objednávku",
    "GDPR": "směrnice GDPR",
    "access-to-all-decks": "Přístup na všechny lodní paluby.",
    "agree-with": "Souhlasím se",
    "agree-with-gdpr": "Souhlasím se zpracováním osobních údajů podle",
    "agree-subscribe-form-with-gdpr": "Odesláním souhlasíte se zpracováním osobních údajů podle",
    "air-ticket-handled-by-costa": "Letenky pro vás zajišťuje náš partner Costa Cruise.",
    "air-ticket-note-with-city": "Součástí vaší objednávky je také zpáteční letenka z {city} do místa startu vaší plavby. Součástí letenky je transfer z letiště k lodi a zpět.",
    "air-ticket-with-transfer": "Letenky jsou včetně transferu z letiště k lodi a zpět.",
    "all-reservation-information-to-register-email-note": "Všechny informace o rezervaci a platbách budou doručeny na váš registrační email {email}",
    "and-back-not-managed": "a zpět není zajištěna",
    "cabin-booking-hint": "Pokud jste dva nebo jen chcete víc místa můžete si objednat celou kajuty s dvěmi lůžky.",
    "cabin-info-text": "<h3>Classic – Kategorie 1</h3><br><ul><li>Kajuta automaticky přidělena systémem</li><li>Nižší patra</li></ul><br><br><h3>Premium – Kategorie 2–4</h3><br><ul><li>Lepší umístění na lodi</li><li>Větší velikost kajuty</li><li>Možnost výběru umístění kajuty (podle dostupnosti)</li></ul>",
    "cabin-is-for-two-passengers": "Každá kajuta obsahuje místo pro dva pasažéry.",
    "cabin-price-all": "Cena celkem pro tuto kajutu",
    "cabin-price-for": "Cena celkem za {for} pro tuto kajutu",
    "call-and-hours": "Volejte Po-Pá 8-18 hod",
    "can-be-found-here": "najdete zde",
    "cancellation-note-1": "0 - 3 dní od objednávky - 0%",
    "cancellation-note-2": "3 dny od objednávky - 60 dní před plavbou - 50%",
    "cancellation-note-3": "Méně jak 60 dní před plavbou - 100%",
    "cancellation-note-4": "Pokud si za sebe najdete náhradníka, storno poplatek je 0%",
    "cancellation-note-5": "45 dní před vyplutím a více - <b>25% z ceny zájezdu</b>",
    "cancellation-note-6": "44-15 dnů před vyplutím - <b>50% z ceny zájezdu</b>",
    "cancellation-note-7": "14-6 dnů před vyplutím - <b>75% z ceny zájezdu</b>",
    "cancellation-note-8": "5-0 dnů před vyplutím - <b>100% z ceny zájezdu</b>",
    "cancellation-note-9": "Změna termínu do 30 dní před vyplutím - <b>50€ / osoba</b>",
    "comfy-tranport-to-port": "Pohodlně vás přepravíme přímo do přístavu odkud loď vypolouvá a po skončení zájezdu zase zpět.",
    "company-buy-note": "Pokud si přejete udělat objednávku na firmu, vyberte tuto možnost. Budeme vás kontaktovat ohledně fakturace.",
    "croatia-note": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse volutpat vitae risus id aliquam. Etiam facilisis, est sed porttitor dictum, ante felis faucibus velit, at auctor nibh dolor ac quam.",
    "cruise-desktop-search-note": "Procestujte svět a zažijte luxus výletní lodě",
    "cruise-not-available": "Tato plavba momentálně není k dispozici.",
    "cruiser-ships-note-1": "Plavba na výletní lodi je nezapomenutelný zážitek.",
    "cruiser-ships-note-2": "Objevujte každý den novou metropoli. Během plavby máte plně k dispozici bary, restaurace, bazény a mnohé další.",
    "cruise-delegate-contanct-form-send-success": "Kontaktní formulář byl odeslán.",
    "every-bed-is-in-2-room": "Každé místo je lůžko v kajutě po dvou osobách.",
    "experience-cruise": "Zažijte plavbu na výletní lodi",
    "fill-how-many-beds-to-reserve": "Zadejte kolik míst na lodi si přejete rezervovat.",
    "fill-how-many-cabins-to-reserve": "Zadejte kolik kajut na lodi si přejete rezervovat.",
    "fill-how-many-ships-to-reserve": "Zadejte kolik lodí na lodi si přejete rezervovat.",
    "find-journey-on-cruiser": "Najděte svoji cestu na výletní lodi",
    "follow-on-socials": "Sleduj YACHTA'S na sítích",
    "follow-cruises-on-socials": "Sleduj Nautyy na sítích",
    "footer-note": "Zážitkové plavby na výletních lodích a plachetnicích. Tato stránka používá cookies",
    "greece-note": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse volutpat vitae risus id aliquam. Etiam facilisis, est sed porttitor dictum, ante felis faucibus velit, at auctor nibh dolor ac quam.",
    "how-many-beds-to-reserve": "Kolik míst chcete rezervovat?",
    "how-many-cabins-to-reserve": "Kolik kajut chcete rezervovat?",
    "how-many-ships-to-reserve": "Kolik lodí chcete rezervovat?",
    "if-not-want-air-ticket": "Pokud o letenku nemáte zájem, jednodušše nic nevyplňujte a tento krok přeskočte.",
    "info-about-not-included-in-price": "Více informací o tom co je a není zahrnuto v ceně zájezdu ",
    "information-about-order": "Na email jsme vám odeslali informace o vaší objednávce. Informace o vašem zájezdu najdete také ve",
    "list-of-passengers": "Seznam cestujících",
    "no-cabin-for-passenger-count": "Pro zvolený počet pasažérů není dostupná kajuta.",
    "no-searched-cruises": "Bohužel jsme nenašli žádné plavby odpovídající Vašim filtrům.",
    "no-worry-travel": "Přejete si cestovat naprosto bez starostí? Pokud ano, využijte možnosti zakoupit si letenku přímo do místa vyplutí. Vyberte si letiště, které vám nejvíc vyhovuje a kupte si jako součást lodního lístku také zpáteční letenku.",
    "non-binding-transport-calculation": "Nezávazná kalkulace dopravy na místo vyplutí pro tuto osobu.",
    "non-binding-request": "Nezávazná poptávka",
    "occupied-two-seats": "obsazení 2 míst",
    "occupied-x-seats": "obsazení {x} míst",
    "only-registered-can-continue": "V objednávce mohou pokračovat pouze registrovaní uživatelé.",
    "order-cancel-status-desc": "byla zrušena",
    "order-cancel-status-title": "Platba neproběhla",
    "order-completed": "Objednávka byla úspěšně vytvořena",
    "order-completed-full-part-1": "Vaši objednávku jsme úspěšně zařadili do našeho systému.",
    "order-completed-full-part-2": "Na email jsme vám odeslali informace o dalším postupu a platební informace.",
    "order-completed-part-1": "Vaši objednávku číslo",
    "order-completed-part-2": "jsme úspěšně zařadili do našeho systému. Na email",
    "order-completed-part-3": "jsme vám odeslali informace o dalším postupu a platební informace.",
    "order-completed-part-4-5-day": "Platbu uhraďte nejpozději do 5 dní.",
    "order-completed-part-4-7-day": "Platbu uhraďte nejpozději do 7 dní.",
    "order-completed-part-5": "Informace o vaší plavbě najdete zde ve",
    "order-completed-part-6": "svém profilu",
    "order-completed-part-7": "nebo na emailu.",
    "order-success-status-desc": "proběhla úspěšně",
    "order-success-status-title": "Platba proběhla úspěšně",
    "order-unsuccess-status-desc": "nebyla dokončena",
    "order-unsuccess-status-title": "Platba byla zrušena",
    "package-fee": "Za tento balíček mohou být účtovány doplňující poplatky. Celkovou cenu se dozvíte v dalším kroku objednávky.",
    "pay-25-deposit-note": "Platbu uhradíte ve dvou krocích. V první části uhradíte depozit ve výši 25% z celkové částky ceny zájezdu. Druhou část (75% z celkové ceny zájezdu) uhradíte nejpozději do 42 dní před odjezdem.",
    "pay-50-deposit-note": "Platbu uhradíte ve dvou krocích. V první části uhradíte depozit ve výši 50% z celkové částky ceny plavby. Druhou část (50% z celkové ceny plavby) uhradíte nejpozději do 60 dní před odjezdem.",
    "pay-amount-at-once": "Úhrada celé částky najednou",
    "pay-everything-note": "Celou platbu uhradíte bankovním převodem naráz. Dovolenou máte tak zaplacenou a nemusíte se už o nic starat. Všechny důležité informace vám zašleme včas na email.",
    "pay-with-bank-description": "Platba klasickým bankovním převodem z vašeho účtu. Platební údaje obdržíte emailem.",
    "pay-with-card": "Zaplatit pomocí platební brány online",
    "pay-with-card-description": "Platba pomocí online platební brány. Platba je provedena okamžitě po potvrzení.",
    "pay-with-order-id": "Platba vaší objednávky číslo",
    "payment-note-1": "Doplatek celé částky ceny plavby je nutné uhradit nejpozději do 60 dní před termínem plavby",
    "payment-note-2": "Platby EUR IBAN CZ70 2010 0000 0025 0148 9149",
    "payment-note-3": "Platby CZK č.ú. 2401489301 / 2010",
    "payment-terms-text": "Po úhradě zálohy ve výšce 400,- EUR nebo 10 000,- CZK Vám potvrdíme místo ve Vámi vybraném termínu. Pokud bude termín obsazený, peníze obratém vracíme nebo se dohodneme na náhradním termínu.",
    "please-different-trip": "Prosím zvolte jiný počet pasažérů nebo vyberte jiný zájezd.",
    "port-fee-note": "V ceně je započítán i celkový poplatek za přístavy za všechny cestující. Poplatek činí celkem { price }.",
    "price-for-single-with": "Cena za 1 osobu při",
    "price-for-two-from": "Cena pro dvě osoby od",
    "price-for-x-from": "Cena za {x} osob od",
    "provide-car-transport": "Zajistíme vám auto",
    "provide-plane-transport": "Zajistíme vám letadlo",
    "redirect-to-payment-gateway": "Budete přesměrování na platební bránu",
    "register-to-finished-order": "Pro dokončení objednávky se prosím registrujte.",
    "ship-booking-hint": "Vhodné pokud máte vlastní partu lidí, víte, že obsadíte celou loď a nechcete v posádce nikoho cizího.",
    "ship-shopping": "Shopping na lodi.",
    "single-place-booking-hint": "Jedno lůžko ve dvoumístné kajutě.",
    "subscribe-text": "Chcete dostávat pravidelné informace o novinkách, zajímavostech a akčních nabídkách?",
    "to-port-and-back": "do přístavu a zpět",
    "total-comfort": "Total Comfort",
    "tour-with-transport": "Tento zájezd zahrnuje možnost dopravy na místo vyplutí. V případě, že označíte toto pole budeme vás kontaktovat s nabídkou dopravy pro tuto osobu. Zaškrtnutím pole neobjednáváte dopravu, ale pouze žádáte o zaslání její nabídky do emailu!",
    "transport-posibility": "Možnost dopravy",
    "transport-posibility-long": "U této plavby je možné využít možnost dopravy na místo vyplutí. Nemusíte si lámat hlavu s dopravu.",
    "transport-to-port": "Doprava do přístavu",
    "transport-to-tour": "Doprava na místo vyplutí",
    "transport-to-port-text-1": "<b>Vlastní doprava</b>",
    "transport-to-port-text-2": "<b>Letecky</b><br>Doporučujeme se do místa doplutí dostavit s dostatečným předstihem. Většina přístavů je nedaleko od letišť s možností spojů hromadnou dopravou nebo taxi. V případě zájmu vám doporučíme, jak se do přístavu dopravit.",
    "transport-to-port-text-3": "<b>Autem</b><br>Parkování je ve všech přístavech dostupné buď přímo na terminálu nebo nedaleko od něj s kyvadlovou dopravou. V případě zájmu vám parkování na místě doporučíme nebo zarezervujeme. Parkování doporučujeme rezervovat s dostatečným předstihem.",
    "transport-to-port-text-4": "<b>Letenky přes lodní společnost:</b><br>v ceně letenky je transfer z letiště do přístavu a zpět<br>20 kg zavazadlo na osobu je v ceně<br>Asistenční služba Costa Asistance 24/7 v případě narušení letu",
    "what-to-bring-text-1": "Dress code je přes den naprosto volný, večer je však formální. Pánům doporučujeme dlouhé kalhoty a košili, dámám kostýmek nebo šaty. Během vaší dovolené na lodi můžete také zažít tematické večery jako jsou: „GALA“, „White out night“ nebo „Retro“. Program určují zaměstnanci lodě.",
    "what-to-bring-text-2": "Upozorňujeme, že některé věci jsou na palubě zakázány a budou u vstupu na loď zabaveny do úschovy. Mimo jiné mezi ně patří žehličky na vlasy, kulmy nebo například dron. Povoleno není ani jídlo a nápoje.",
    "what-to-bring-text-3": "Celý seznam zakázaných položek naleznete zde: <a href=\"https://www.costacruises.eu/useful-links/prohibited-articles.html\">https://www.costacruises.eu/useful-links/prohibited-articles.html</a>",
    "luggage-text-1": "Zavazadla musí být před naloděním opatřena štítkem, který si vytisknete z portálu <b>My Costa.</b> Při nalodění zavazadla předáte personálu, který je dopraví přímo do Vaší kajuty.",
    "luggage-text-2": "<b>Doporučujeme si u sebe nechat nejpotřebnější věci.</b> Dodání zavazadel do kajuty trvá většinou okolo dvou hodin.",
    "luggage-text-3": "<b>Povolená zavazadla, dle délky plavby:</b>",
    "luggage-text-4": "<b>Plavby do 7 dnů:</b> 1 příruční a 1 velké zavazadlo<br><b>Plavby 8-15 dnů:</b> 1 příruční a 2 velká zavazadla<br><b>Plavby nad 15 dnů:</b> 1 příruční a 3 velká zavazadla",
    "trip-not-available": "Tento zájezd momentálně není k dispozici.",
    "try-later": "Zkuste to prosím později.",
    "unlimited-food-drinks": "Neomezená konzumace jídla a pití.",
    "unlimited-wellness": "Neomezený přístup do wellness.",
    "we-chose-best-accommodation": "Vybrali jsme nejlepší dostupné ubytování, které splní vaše potřeby.",
    "with-bpdrink-package": "Nealko nápoje a wifi",
    "with-broken-package": "????",
    "with-earlybkg-package": "Early booking - Plná penze",
    "with-lastmin-package": "Last minute - Plná penze",
    "with-lmdrink-package": "Last minute - All inclusive",
    "with-prexcdr-package": "All inclusive a exkurze",
    "with-round-world-package": "Cesta kolem světa - plná penze",
    "with-bestpriceflight-package": "Best Price flight",
    "with-individual-package": "Cesta kolem světa",
    "with-last-minute-package": "Last Minute",
    "with-my-cruise-package": "My Cruise",
    "with-promo-package": "PROMO",
    "with-ultra-all-inclusive": " Ultra All inclusive",
    "with-ultra-all-inclusive-last-minute": "Last minute - Ultra all inclusive",
    "with-96h-package": "96h promo - Plná penze",
    "with-96hdrink-package": "96h promo - All inclusive",
    "with-package": "s balíčkem",
    "without-price-for-transport": "Bez ceny za dopravu",
    "yacht-desktop-search-note-1": "Zažijte",
    "yacht-desktop-search-note-2": "#neskutečné",
    "yacht-desktop-search-note-3": "dobrodružství na jachtě.",
    "yacht-note-1": "Zažijte neskutečnou jízdu plachetnicí.",
    "yacht-note-2": "Každý den objevujte nové ostrovy, laguny a města. Za pomoci zkušeného kapitána se sami rozhodnete kam chcete plout.",
    "cookies-content": "K personalizaci obsahu a reklam, poskytování funkcí sociálních médií a analýze naší návštěvnosti využíváme soubory cookie. Informace o tom, jak náš web používáte, sdílíme se svými partnery pro sociální média, inzerci a analýzy. Partneři tyto údaje mohou zkombinovat s dalšími informacemi, které jste jim poskytli nebo které získali v důsledku toho, že používáte jejich služby.",
    "cookies-functional-text": "Nutné cookies pomáhají, aby byla webová stránka použitelná tak, že umožní základní funkce jako navigace stránky a přístup k zabezpečeným sekcím webové stránky. Webová stránka nemůže správně fungovat bez těchto cookies.",
    "cookies-preferential-text": "Preferenční cookies umožňují, aby si webová stránka zapamatovala informace, které mění, jak se webová stránka chová nebo jak vypadá. Je to například preferovaný jazyk nebo region, kde se nacházíte.",
    "cookies-analytic-text": "Statistické cookies pomáhají majitelům webových stránek, aby porozuměli, jak návštěvníci používají webové stránky. Anonymně sbírají a sdělují informace.",
    "cookies-marketing-text": "Marketingové cookies jsou používány pro sledování návštěvníků na webových stránkách. Záměrem je zobrazit reklamu, která je relevantní a zajímavá pro jednotlivého uživatele a tímto hodnotnější pro vydavatele a inzerenty třetích stran.",
    "restrictions-text-1": "<b>Jakékoli omezení nebo speciální požadavky</b> je nutné sdělit při rezervaci plavby.",
    "restrictions-text-2": "<b>Těhotné ženy</b> mohou cestovat do ukončeného 23. týdne těhotenství s potvrzením od lékaře (v angličtině).",
    "restrictions-text-3": "<b>Děti do 18 let musí cestovat s dospělou osobou.",
    "restrictions-text-4": "<b>Kojenci</b> musí mít v době nalodění minimálně <b>6 měsíců</b>, pro plavby nad 15 dní a transatlantické plavby je spodní hranice <b>12 měsíců.</b>",
    "fun-on-ship-text-1": "Lodě flotily <b>Costa Cruises</b> nabízí širokou škálu <b>zábavních aktivit, atrakcí</b> a <b>animačních programů</b> pro všechny věkové kategorie.",
    "fun-on-ship-text-2": "Využít můžete <b>vnitřní i venkovní bazény, vířívky, wellness, masáže, spa, jógu, pilates, fitness, venkovní posilovnu, zážitkové restaurace a bary.</b>",
    "fun-on-ship-text-3": "Lodě také nabízejí divadlo s každodenním představením, noční klub, silent disco, piano bar, kasino, nákupní centrum, lanové centrum, aquapark a mnoho dalšího.",
    "fun-on-ship-text-4": "Pro nejmenší je k dispozici Squok club, který je určen pro děti od 3 do 17 let (hlídání dětí 1-3 let je za příplatek).",
    "fun-on-ship-text-5": "Klub je otevřen od 9:00 do 24:00 a děti jsou v něm rozděleny do skupin dle věku.Squok club zajišťuje <b>animační programy, sportovní turnaje, disco, taneční a karaoke soutěže.</b>",
    "excursions-text-1": "Exkurze lze vybrat v portálu MyCosta. Zde si můžete zarezervovat exkurze jednotlivě, nebo při zakoupení MyExplorations, ve kterém máte 3 exkurze v ceně. (Na výběr máte pouze z exkurzí se štítkem MyExplorations) Exkurze doporučujeme rezervovat s dostatečným předstihem. ",
    "excursions-text-2": "Při zastávkách lodí v přístavu se můžete libovolně pohybovat mezi lodí a městem/ostrovem a kdykoliv se na loď vrátit. Pro vstup na loď je vyžadována palubní karta a při návratu probíhá bezpečnostní kontrola. Kdykoliv se během dne můžete vrátit zpět na loď. Doprava z přístavu a zpět je možná veřejnou dopravou (dopravní spoje jsou ve většině přístavů nebo v docházkové vzdálenosti) případně je k dispozici možnost objednání shuttle busu nebo taxi. (za poplatek)",
    "portal-mycosta-text-1": "Po vytvoření a zaplacení rezervace vám přijdou přihlašovací údaje do portálu MyCosta, kde si 30 dní před vyplutím a po uhrazení celé částky můžete udělat online check-in a stáhnout palubní lístky a štítky na zavazadla.",
    "portal-mycosta-text-2": "Najdete zde také veškeré informace o plavbě, případně letenkách a transferech, zakoupených a dostupných balíčcích a exkurzích. Můžete zde dále svou plavbu personifikovat.",
    "app-costa-text-1": "Doporučujeme si stáhnout aplikaci Costa na vaše mobilní zařízení. Po přihlášení zde naleznete veškeré informace, podobně jako v portálu MyCosta. Po připojení na místní síť na lodi zde uvidíte veškerý program, mapu, zakoupené balíčky, můžete přes ni komunikovat s ostatními cestujícími a mnoho dalšího. Plavbu vám velmi zpříjemní a vše zjednoduší. Budete vždy vědět, co se kde na lodi děje.",
    "online-check-in-feature-1": "Dostupný 30 dní před vyplutím po uhrazení celé částky",
    "online-check-in-feature-2": "V <b>aplikaci Costa v mobilní telefonu</b> – přihlášení příjmením a číslem rezervace ",
    "online-check-in-feature-3": "V <b>portálu My Costa</b> - přihlašovací údaje obdržíte v e-mailu po uhrazení rezervace.",
    "online-check-in-feature-4": "Po vyplnění osobních údajů a uhrazení celé částky si budete moci stáhnout palubní lístky včetně štítku na zavazadla.",
    "payments-on-ship-feature-1": "<b>Není potřeba mít hotovost.</b>",
    "payments-on-ship-feature-2": "Útraty na lodi se načítají na palubní kartu.",
    "payments-on-ship-feature-3": "Po nalodění si zaregistrujete v automatu na lodi Vaši debetní nebo kreditní kartu.",
    "payments-on-ship-feature-4": "<b>Úhrada útraty včetně servisních poplatků</b> probíhá na konci plavby automaticky strhnutím částky z Vaší karty, kterou jste zaregistrovali.",
    "internet-connection-feature-1": "Uvnitř lodi a dále od pobřeží není signál dostupný",
    "internet-connection-feature-2": "V internetové kavárně za poplatek <b>0,25€/min</b>",
    "internet-connection-feature-3": "Balíček <b>WhatsApp - 5€/den</b>",
    "internet-connection-feature-4": "Balíček <b>Sociální sítě - 10€/den (9€ v aplikaci Costa)</b>",
    "internet-connection-feature-5": "<b>Neomezený internet - 17€/den (14€ v aplikaci Costa)</b>",
    "internet-connection-feature-6": "Signál je dostupný poblíž přístavu a pobřeží.",
    "medical-care-feature-1": "Na každé lodi je <b>nemocnice.</b>",
    "medical-care-feature-2": "Ošetření <b>není hrazeno z Evropského zdravotního pojištění.</b>",
    "medical-care-feature-3": "Doporučujeme si zřídit cestovní zdravotní pojištění – buď vlastní nebo Vám můžeme zprostředkovat pojištění <b>Costa Relax.</b> od společnosti Europ Assistance",
    "travel-documents-feature-1": "<b>Pas</b> nebo <b>občanský průkaz</b> (pro plavby po EU).",
    "travel-documents-feature-2": "<b>Palubní vstupenka</b> (k vytištění v portálu MyCosta).",
    "travel-documents-feature-3": "<b>Zdravotní dotazník</b> (k vytištění v portálu MyCosta).",
    "travel-documents-feature-4": "<b>Víza</b> (v případě vízové povinnosti).",
    "service-fee-costa": "Na každého hosta staršího 14 let se vztahuje povinný servisní poplatek 11 EUR za den. Děti 4 až 14 let hradí 50%. Tento poplatek není zahrnut v ceně a bude účtován přímo na místě.",
    "service-fee-msc": "Cena je bez skrytých poplatků a je již včetně servisních i přístavních poplatků."
  },
  "META-DESCRIPTIONS": {
    "homepage": "Vydejte se na plavbu s oficiálním partnerem MSC a Costa Cruises. Osobní přístup, plavby s delegátem a nejlepší ceny online.",
    "destination": "{destination} - Costa Cruise's. Luxusní plavby do Karibiku, Středomoří, Evropy, Perského Zálivu nebo Ameriky. Plavby pro skupiny i firmy. Vybírejte!",
    "cruise-detail": "{cruiseName} - Costa Cruise's. Stylové kajuty, špičková gastronomie, vybavené bary, animační programy. Plavby pro skupiny i firmy. Vybírejte!",
    "ship-detail": "{shipName} - Costa Cruise's. Máme 11 luxusních lodí s kapacitou tisíců pasažérů. Plavby pro skupiny i firmy. Vybírejte!",
    "content-page": "{pageName} - Costa Cruise's. 11 luxusních lodí. Karibik, Středomoří, Evropa, Perský záliv, Amerika. Plavby pro skupiny i firmy. Vybírejte!",
    "search": "Plavby s Costa Cruises a MSC Cruises",
    "search-luxury-cruises": "Luxusní plavby",
    "search-promo": "Akční plavby s Costa Cruises a MSC Cruises",
    "search-black-friday": "Black Friday",
    "reservation-package": "{cruiseName} - Výběr balíčku",
    "cruises-with-delegate-search": "Vydejte se na plavbu s českým delegátem. Komfort, osobní přístup a bezstarostná dovolená na lodi MSC a Costa Cruises.",
    "cruises-with-delegate-detail": "{cruiseName} • Plavba s delegátem",
    "for-groups": "Plánujete plavbu s přáteli, rodinou nebo kolegy? Skupinové výhody, pohodlná rezervace a osobní servis.",
    "for-firms": "Originální teambuilding nebo konference na lodi. Plavby MSC a Costa Cruises na míru pro firmy a jejich týmy.",
    "msc-cruises": "Vyplujte s MSC Cruises! Moderní lodě, all inclusive plavby a nezapomenutelné zážitky na moři.",
    "costa-cruises": "Užijte si dovolenou s Costa Cruises! Skvělá gastronomie, luxusní lodě a jedinečné destinace.",
    "how-it-works-msc": "Jak to funguje - MSC Cruises",
    "how-it-works-costa": "Jak to funguje - Costa Cruises",
    "destinations": "Destinace",
    "articles": "Články",
    "fleet-costa-cruises": "Výletní lodě Costa Cruises",
    "fleet-msc-cruises": "Výletní lodě MSC Cruises"
  },
  "TITLES": {
    "homepage": "Plavby MSC a Costa Cruises – Dovolená na lodi bez starostí",
    "destination": "{destination} • Nautyy",
    "cruise-detail": "{cruiseName} • Nautyy",
    "ship-detail": "{shipName} • Nautyy",
    "content-page": "{pageName} • Nautyy",
    "search": "Plavby s Costa Cruises a MSC Cruises",
    "search-luxury-cruises": "Luxusní plavby",
    "search-promo": "Akční plavby s Costa Cruises a MSC Cruises",
    "search-black-friday": "Black Friday",
    "reservation-package": "{cruiseName} - Výběr balíčku",
    "cruises-with-delegate-search": "Plavby s delegátem – Pohodlí a jistota na moři",
    "cruises-with-delegate-detail": "{cruiseName} • Plavba s delegátem",
    "for-groups": "Skupinové plavby – Cestujte spolu, užijte si víc",
    "for-firms": "Firemní plavby – Teambuilding na vlnách",
    "msc-cruises": "Plavby MSC Cruises – Luxusní dovolená na lodi",
    "costa-cruises": "Plavby Costa Cruises – Italský styl na moři",
    "how-it-works-msc": "Jak to funguje - MSC Cruises",
    "how-it-works-costa": "Jak to funguje - Costa Cruises",
    "destinations": "Destinace",
    "articles": "Články",
    "fleet-costa-cruises": "Výletní lodě Costa Cruises",
    "fleet-msc-cruises": "Výletní lodě MSC Cruises"
  },
  "MULTISELECT": {
    "placeholder": "Vyberte",
    "selectLabel": "Vybrat",
    "selectedLabel": "Vybráno",
    "deselectLabel": "Odebrat",
    "noResult": "Nic nenalezeno",
    "noOptions": "Žádné možnosti"
  }
} as const;
